import { React, useCallback, useEffect, useRef, useState } from "react";
import tournamentlist from "../../images/tournamentlist.png";
import Diamond from "../../images/Diamond.png";
import arrow from "../../images/rightside.png";
import BaseHome from "../Home/BaseHome";
import Button from "../CommonFields/Button";
import { useNavigate } from "react-router";
import { routesFrontend } from "../RouterFiles/routes";
import { scrimsByGameNUser, scrimById, scrimsList } from "../../api/scrim.api";
import { t } from "i18next";

import {
  findValueByName,
  formatDate,
  formatTime,
} from "../../Utilities/helper";
import { toastInfo, toastSuccess } from "../../Utilities/toast";
import ListLoader from "../Common/ListLoader";
import moment from "moment";
const PrivateScrimList = ({ data }) => {
  const navigate = useNavigate();

  const [scrimList, setScrimList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [gameName, setGameName] = useState("");

  useEffect(() => {
    let selectedGameName = localStorage.getItem("activeGame");
    setGameName(selectedGameName.toLowerCase());
  }, []);

  useEffect(() => {
    const successScrim = localStorage.getItem("toastMessage");
    if (successScrim) {
      toastSuccess(successScrim);
      localStorage.removeItem("toastMessage");
    }
  }, []);

  useEffect(() => {
    localStorage.removeItem("scrimDetails");
    localStorage.removeItem("selectedGameType");
  }, []);

  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);

  const loadMore = async () => {
    setLoading(true)
    fetchScimsByGameAndUser();
  };

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading]
  );

  const formatTimeString = (isoString) => {
    const date = new Date(isoString);
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12 || 12; // Convert 0 hours to 12
    return `${String(hours).padStart(2, "0")}:${minutes} ${period}`;
  };

  const fetchScimsByGameAndUser = async () => {
    try {
      // if (currentPage === 1) setLoading(true);
      var response = await scrimsList({
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "date",
          sortDirection: "desc",
        },
        game: localStorage.getItem("activeGameId"),
      });
      // if (currentPage === 1)
      setLoading(false);
      if (response?.success && response?.data) {
        setScrimList([...scrimList, ...response?.data]);
        setTotalPages(response?.totalPages);
      }
    } catch (error) {
      // if (currentPage === 1) 
      setLoading(false);
    }
  };

  const checkStatus = (status) => {
    if (status === "Completed") {
      return (
        <div className="col-3 private-contest-status mt-3 mycontest-container-box-status-completed">
          <div className="mycontest-container-box-status mycontest-container-box-status-completed">
            {status}
          </div>
        </div>

      );
    } else if (status === "In Process" || status === "In Review" || status === "Review") {
      return (
        <div className="col-3 private-contest-status mt-3 mycontest-container-box-status-inprocess">
          <div className="mycontest-container-box-status mycontest-container-box-status-inprocess">
            {status}
          </div></div>
      );
    } else if (status === "Cancelled" || status === "Canceled") {
      return (
        <div className="col-3 private-contest-status mt-3 mycontest-container-box-status-cancelled bg-cancelled">
          <div className="mycontest-container-box-status mycontest-container-box-status-cancelled bg-cancelled">
            {status}
            {/* Cancelled */}
          </div>
        </div>
      );
    } else {

      return (
        <div className="col-3 private-contest-status mt-3">
          <div className="mycontest-container-box-status">{status}</div></div>);
    }
  };
  return (
    <>
      <BaseHome title={gameName || ""} onBackClick={() => {
        navigate(`/game-type/${localStorage.getItem("activeGameId")}`);
      }}>
        <div className={`tournament-card-container position-relative`}style={{ paddingBottom:"4rem" }}>
          {(
            scrimList && scrimList?.length > 0 ? (
              scrimList?.map((scrim, index) => {
                const totalPlayers = scrim?.noOfPlayerCapacity;
                const joinedPlayers = scrim?.noOfJoinedPlayer;
                const percentage = (joinedPlayers / totalPlayers) * 100;

                return (
                  <div
                    key={scrim._id}
                    ref={
                      scrimList?.length === index + 1
                        ? lastPostElementRef
                        : null
                    }
                  >
                    {checkStatus(scrim?.status)}

                    <div className="container tournament-card--wrap">
                      <div
                        className="tournament-card mb-4 pb-0"
                        style={{ borderRadius: "0px 20px 20px 20px" }}
                      >
                        <div className="card-body d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="card-title">
                              {scrim?.title?.length > 25 ? (
                                <marquee> {scrim?.title}</marquee>
                              ) : (
                                scrim?.title
                              )}
                              {/* {scrim?.title} */}
                            </div>
                            <button
                              className="btn rules-btn"
                              style={{ width: "fit-content" }}
                              onClick={() => {
                                navigator.clipboard.writeText(scrim?.shortCode);
                                toastInfo("short code copied");
                              }}
                            >
                              ID-{scrim?.shortCode}
                            </button>
                          </div>
                          <hr style={{margin:"0.5rem 0"}}></hr>
                          <div className="row ">
                            <div className="col-12">
                              <div className="tournament-card-detail">
                                <div className="row">
                                  <div className="col-12 tournament-card-box--wrap">
                                    <div className="row">
                                      <div className="col-3 tournament-card-box">
                                        <div className="detail-item">
                                          <div className="tournament-detail-label letter-spacing">
                                            {/* {scrim?.date.length > 7 ? (
                                    <marquee> {moment(new Date(scrim?.date)).format('DD/MM/YYYY')}</marquee>
                                  ) : (
                                    moment(new Date(scrim?.date)).format('DD/MM/YYYY')
                                  )} */}

                                            {moment(new Date(scrim?.date)).format('DD/MM/YYYY')}
                                          </div>
                                          <div className="tournament-detail-value">
                                            date
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-3 tournament-card-box">
                                        <div className="detail-item">
                                          <div className="tournament-detail-label">
                                            {moment(new Date(scrim?.time)).format('h:mm A')}
                                          </div>
                                          <div className="tournament-detail-value">
                                            time
                                          </div>
                                        </div>
                                      </div>
                                      {
                                        (scrim?.titles?.[0]?.name &&
                                          scrim?.titles?.[0]?.value) && (
                                          <div className="col-3 tournament-card-box">
                                            <div className="detail-item">
                                              <div className="tournament-detail-label">
                                                {scrim?.titles?.[0]?.value.length > 9 ? (
                                                  <marquee>
                                                    {scrim?.titles?.[0]?.value}
                                                  </marquee>
                                                ) : (
                                                  scrim?.titles?.[0]?.value
                                                )}
                                                {/* {scrim?.titles?.[0]?.value} */}
                                              </div>
                                              <div className="tournament-detail-value">
                                                {scrim?.titles?.[0]?.name.length > 9 ? (
                                                  <marquee>
                                                    {scrim?.titles?.[0]?.name}
                                                  </marquee>
                                                ) : (
                                                  scrim?.titles?.[0]?.name
                                                )}
                                                {/* {scrim?.titles?.[0]?.name} */}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {
                                        (scrim?.titles?.[1]?.name &&
                                          scrim?.titles?.[1]?.value) && (
                                          <div className="col-3 tournament-card-box">
                                            <div className="detail-item">
                                              <div className="tournament-detail-label">
                                                {scrim?.titles?.[1]?.value.length > 11 ? (
                                                  <marquee>
                                                    {scrim?.titles?.[1]?.value}
                                                  </marquee>
                                                ) : (
                                                  scrim?.titles?.[1]?.value
                                                )}
                                                {/* {scrim?.titles?.[1]?.value} */}
                                              </div>
                                              <div className="tournament-detail-value">
                                                {scrim?.titles?.[1]?.name.length > 11 ? (
                                                  <marquee>
                                                    {scrim?.titles?.[1]?.name}
                                                  </marquee>
                                                ) : (
                                                  scrim?.titles?.[1]?.name
                                                )}
                                                {/* {scrim?.titles?.[1]?.name} */}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-2">
                            <div className="tournament-details-winnings ">
                              <div className="d-flex justify-content-between">
                                <p className="prize-info">
                                  winners{" "}
                                  <span className="tournament-prizepool">
                                    {" "}
                                    {scrim?.noOfWinner !== undefined
                                      ? scrim?.noOfWinner
                                      : "N/A"}
                                  </span>
                                </p>
                                <p className="join-info">
                                  hosted by{" "}
                                  <span className="tournament-prizepool">
                                    {scrim?.hostedByName?.length > 6 ? (
                                      <marquee className="hosted_by">
                                        {scrim?.hostedByName}
                                      </marquee>
                                    ) : (
                                      scrim?.hostedByName
                                    )}
                                    {/* {scrim?.hostedByName} */}
                                  </span>
                                </p>
                                <p
                                  className="private-scrim-manage-btn"
                                  style={{ cursor: "pointer", alignItems:"center"}}
                                  onClick={() =>
                                    navigate(
                                      `/private-contest/manage-contest/${scrim?.scrimId}`
                                    )
                                  }
                                  key={scrim.scrimId}
                                >
                                  {" "}
                                  manage
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            {/* Progress Bar */}
                            <div
                              className="progress"
                              style={{ height: "6px", width: "100%" }}
                            >
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                  width: `${percentage}%`, // Example percentage
                                  backgroundColor: "#9F6693",
                                }}
                                aria-valuenow={joinedPlayers}
                                aria-valuemin="0"
                                aria-valuemax={totalPlayers}
                              ></div>
                            </div>
                          </div>
                          <p className="progressbar-text mt-2">
                            <div>{joinedPlayers} {joinedPlayers > 1 ? 'players' : 'player'} joined</div>
                            <div>{totalPlayers}</div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (!isLoading &&
              <div
                className={`tournament-card-container private-scrim-norecfound`}
              >
                <div className="no-contest-found-container text-center mt-5">
                  <h2>no contest found</h2>
                  <p>it seems like you haven’t created any contest yet</p>
                  <h6
                    onClick={() =>
                      navigate("/" + routesFrontend.howtoCreateScrim)
                    }
                    style={{ cursor: "pointer", marginBottom: "2.5rem" }}

                  >
                    <a className="text-danger">how to create a contest</a>
                  </h6>
                  <Button
                    className="create-contest-btn"
                    text="create a contest"
                    onClick={() =>
                      navigate(
                        "/" +
                        routesFrontend.privateScrim +
                        "/" +
                        routesFrontend.createScrim
                      )
                    }
                  />
                </div>
              </div>
            )
          )}
          {/* {isLoading && <div className='w-100 d-flex justify-content-center'> <ListLoader /></div>} */}
          {isLoading && <div className={currentPage === 1 ? 'w-100 d-flex justify-content-center no-record-found-center' : 'w-100 d-flex justify-content-center'}> <ListLoader /></div>}

          {scrimList?.length > 0 ? (
            <div className="custome-common-btn-bottom">
              <Button
                className="create-contest-btn"
                text={t("private_contest.create_a_contest")}
                onClick={() =>
                  navigate(
                    "/" +
                    routesFrontend.privateScrim +
                    "/" +
                    routesFrontend.createScrim
                  )
                }
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </BaseHome>
    </>
  );
};

export default PrivateScrimList;
